import React from 'react';
import CategoriesRow from './CategoriesRow';
import { CategoryType } from '../types';

interface Props {
  data: CategoryType[];
  onEdit: (idx: string) => void;
}

const colWidths = [
  'text-left w-[80%]',
  'text-right w-[20%]',
  'text-right w-[1%]',
];

const headers = [
  'Title',
  'Date Added',
  'Action',
];

const CategoriesTable: React.FC<Props> = ({ data, onEdit }) => {

  return (
    <div className='relative h-full'>
      <div
        className='absolute inset-0 scrollbar scrollbar-thumb-[#EEEEEE] scrollbar-track-transparent overflow-auto'
      >
        <table className='min-w-full  table-fixed text-left'>
          <colgroup>
            {colWidths.map((w, i) => (
              <col key={i} className={w} />
            ))}
          </colgroup>
          <thead className='sticky top-0 z-10 bg-white border-b'>
            <tr>
              {headers.map((h, i) => (
                <th
                  key={i}
                  className={`px-4 py-[18px] font-bold whitespace-nowrap ${i === headers.length - 1 ? 'pr-[21px]' : ''}`}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((c) => (
              <CategoriesRow
                key={c.id}
                category={c}
                onEdit={onEdit}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CategoriesTable;
